// Fallback data, updated on 25/03/2025
const GITHUB = {
  count: 36597,
  commits: 19511,
  closedIssues: 7544,
  contributors: 2470,
  forks: 3986,
  pullRequests: 6254,
  openIssues: 268,
};

export default GITHUB;
